<footer class="py-6 px-10 lg:px-24 xl:px-44 2xl:px-72 basis-0 flex flex-col md:flex-row items-center justify-between gap-2 bg-ppdms-primary text-sm md:text-base text-ppdms-light text-center [&_*]:font-['IBM_Plex_Mono',_monospace]">
  <p>© 2026 PPDMS. All rights reserved.</p>
  <p>built for the public sector</p>
</footer>
